import { API_URL, ControllerName } from '../utils/defaults'
import $api from './http'

export class ApiService {
	constructor() {}

	static users = {
		checkAccount: async (dto: any) => {
			return await $api.post(this.buildUrl(ControllerName.USERS, `auth/check`), dto)
		},
		signInWithCode: async (dto: any) => {
			return await $api.post(this.buildUrl(ControllerName.USERS, `auth/signin`), dto)
		},
		signInWithToken: async (dto: any) => {
			return await $api.post(this.buildUrl(ControllerName.USERS, `auth/signin/token`), dto)
		},
		logout: async () => {
			return await $api.post(ApiService.buildUrl(ControllerName.USERS, `auth/logout`))
		},
		signUpWithCode: async (dto: any) => {
			return await $api.post(this.buildUrl(ControllerName.USERS, `auth/signup`), dto)
		},

		signUpForOrder: async (dto: any) => {
			return await $api.post(this.buildUrl(ControllerName.USERS, `signupfororder`), dto)
		},

		lostPassword: async (dto: any) => {
			return await $api.post(this.buildUrl(ControllerName.USERS, `lost/sendcode`), dto)
		},

		signIn: async (dto: any) => {
			return await $api.post(this.buildUrl(ControllerName.USERS, `signin`), dto)
		},
		signInWithGoogle: async (jwtToken: string) => {
			return await $api.post(this.buildUrl(ControllerName.USERS, `signin/google`), { token: jwtToken })
		},
		reauthWithGoogle: async (jwtToken: string) => {
			return await $api.post(this.buildUrl(ControllerName.USERS, `reauth/google`), { token: jwtToken })
		},
		updateAccount: async (dto: any, userId: number) => {
			return await $api.put(this.buildUrl(ControllerName.USERS, `account/${userId}`), dto)
		},
		updatePassword: async (id: number, dto: any) => {
			return await $api.post(this.buildUrl(ControllerName.USERS, `account/${id}/password`), dto)
		},
		deleteAccount: async (userId: number) => {
			return await $api.delete(this.buildUrl(ControllerName.USERS, `account/${userId}`))
		},
		getAccount: async () => {
			return await $api.get(this.buildUrl(ControllerName.USERS, `account`))
		},

		getUsers: async (query: any) => {
			return await $api.get(this.buildUrl(ControllerName.USERS, `list${this.buildParams(query)}`))
		},
		getAccountById: async (userId: number) => {
			return await $api.get(this.buildUrl(ControllerName.USERS, `account/byid/${userId}`))
		},

		sendAdventureTask: async (dto: any) => {
			return await $api.post(this.buildUrl(ControllerName.USERS, `adventure/task`), dto)
		},
		getAdventureTasks: async (query: any) => {
			return await $api.get(this.buildUrl(ControllerName.USERS, `adventure/list${this.buildParams(query)}`))
		},
		getReCall: async (query: any) => {
			return await $api.get(this.buildUrl(ControllerName.USERS, `re_call/list${this.buildParams(query)}`))
		},
		createReCall: async (dto: any) => {
			return await $api.post(this.buildUrl(ControllerName.USERS, `re_call/create`), dto)
		},
		updateAdventureTask: async (id: number, dto: any) => {
			return await $api.put(this.buildUrl(ControllerName.USERS, `adventure/task/${id}`), dto)
		},
		deleteAdventureTask: async (id: number) => {
			return await $api.delete(this.buildUrl(ControllerName.USERS, `adventure/task/${id}`))
		},
	}

	static franchises = {
		getAllFranchises: async () => {
			return await $api.get(this.buildUrl(ControllerName.FRANCHISES, `list/`))
		}, //drowsy
		createFranchise: async (dto: any) => {
			return await $api.post(this.buildUrl(ControllerName.FRANCHISES, `list`), dto)
		},
		getFranchiseByStudioId: async (id: number) => {
			return await $api.get(this.buildUrl(ControllerName.FRANCHISES, `list/byid/${id}`))
		},
	}

	static studios = {
		createPayment: async (dto: any) => {
			return await $api.post(this.buildUrl(ControllerName.STUDIOS, `payments`), dto)
		},
		checkPayment: async (pid: number) => {
			return await $api.get(this.buildUrl(ControllerName.STUDIOS, `payments/${pid}`))
		},

		getMetros: async () => {
			return await $api.get(this.buildUrl(ControllerName.STUDIOS, `dadata/metros`))
		},

		getLinesMetro: async () => {
			return await $api.get(this.buildUrl(ControllerName.STUDIOS, `lines/metro`))
		},

		getNewStudios: async (country_id: number = 0, cat: string = 'all') => {
			return await $api.get(this.buildUrl(ControllerName.STUDIOS, `new_studios?country_id=${country_id}&cat=${cat}`))
		},

		getMetro: async () => {
			return await $api.get(this.buildUrl(ControllerName.STUDIOS, `get_metro`))
		},
		updateMetro: async () => {
			return await $api.get(this.buildUrl(ControllerName.STUDIOS, `dadata/filler`))
		},

		saveReviews: async (dto: any) => {
			return await $api.post(this.buildUrl(ControllerName.STUDIOS, `p_reviews`), dto)
		},
		saveRating: async (dto: any) => {
			return await $api.post(this.buildUrl(ControllerName.STUDIOS, `p_rating`), dto)
		},
		disableRatingSource: async (dto: { studio_id: number; source: 'gis' | 'yandex' }) => {
			return await $api.post(this.buildUrl(ControllerName.STUDIOS, `rating/disable`), dto)
		},

		updateRating: async (dto: any) => {
			return await $api.post(this.buildUrl(ControllerName.PARSER, `page`), dto)
		},

		getPriorityStudios: async () => {
			return await $api.get(this.buildUrl(ControllerName.STUDIOS, `top_studios`))
		},
		updatePriorityStudios: async (dto: any) => {
			return await $api.post(this.buildUrl(ControllerName.STUDIOS, `top_studios/update`), dto)
		},

		getSections: async (sid: number) => {
			return await $api.get(this.buildUrl(ControllerName.STUDIOS, `sections/${sid}`))
		},
		createSection: async (dto: any) => {
			return await $api.post(this.buildUrl(ControllerName.STUDIOS, `section`), dto)
		},
		updateSection: async (id: number, dto: any) => {
			return await $api.put(this.buildUrl(ControllerName.STUDIOS, `section/${id}`), dto)
		},
		updateSectionsOrder: async (sid: number, sectionIds: number[]) => {
			return await $api.put(this.buildUrl(ControllerName.STUDIOS, `sections/${sid}/order`), {
				section_ids: sectionIds,
			})
		},
		deleteSection: async (id: number) => {
			return await $api.delete(this.buildUrl(ControllerName.STUDIOS, `section/${id}`))
		},

		getAllTickets: async (query: any) => {
			return await $api.get(this.buildUrl(ControllerName.STUDIOS, `tickets${this.buildParams(query)}`))
		},
		createStudioTicket: async (dto: any) => {
			return await $api.post(this.buildUrl(ControllerName.STUDIOS, `ticket`), dto)
		},
		updateStudioTicket: async (id: number, dto: any) => {
			return await $api.put(this.buildUrl(ControllerName.STUDIOS, `ticket/${id}`), dto)
		},
		deleteStudioTicket: async (id: number) => {
			return await $api.delete(this.buildUrl(ControllerName.STUDIOS, `ticket/${id}`))
		},

		getStats: async (dto: any) => {
			const response = await $api.post(this.buildUrl(ControllerName.STUDIOS, 'stats'), dto)
			return response.data
		},
		generateMissingBookings: async (dto: { year: string; month: string }) => {
			return await $api.post(this.buildUrl(ControllerName.STUDIOS, `generate-missing`), dto)
		},

		getStudios: async (query: {
			country_id: number
			city_id: number
			page: number
			limit: number
			search: string
			searchFilter: string
			category: string
			order: string
			order_by: string
			status: string
			date: string
			time: string
			service: string
			sort?: string
			metro?: string
			facils?: string
			servs?: string
			price?: string
			square?: string
			rating?: string
			stock?: string
			hashtags?: string
			randomSeed?: number
		}) => {
			return await $api.get(this.buildUrl(ControllerName.STUDIOS, `list${this.buildParams(query)}`))
		},
		getStudioViews: async () => {
			return await $api.get(this.buildUrl(ControllerName.STUDIOS, `views`))
		},
		getStudioById: async (id: number) => {
			return await $api.get(this.buildUrl(ControllerName.STUDIOS, `list/byid/${id}`))
		},
		getStudioStats: async (id: number, dateStart: string, dateEnd: string) => {
			return await $api.get(
				this.buildUrl(ControllerName.STUDIOS, `stats/${id}?dateStart=${dateStart}&dateEnd=${dateEnd}`)
			)
		},
		getStudioChart: async (id: number, dateStart: string, dateEnd: string, by_day: number = 0) => {
			return await $api.get(
				this.buildUrl(
					ControllerName.STUDIOS,
					`chart/${id}?date_start=${dateStart}&date_end=${dateEnd}&by_day=${by_day}`
				)
			)
		},
		getStudioByLink: async (link: string, city: string = '') => {
			const cityQuery = city ? `?city=${encodeURIComponent(city)}` : ''
			return await $api.get(this.buildUrl(ControllerName.STUDIOS, `list/bylink/${encodeURIComponent(link)}${cityQuery}`))
		},
		getStudioReviews: async (studio_id: number) => {
			return await $api.get(this.buildUrl(ControllerName.STUDIOS, `list/reviews/${studio_id}`))
		},

		getStudioBookings: async (id: number, date: string) => {
			return await $api.get(this.buildUrl(ControllerName.STUDIOS, `list/bookings/${id}?date=${date}`))
		},
		getGlobalPromoRes: async () => {
			return await $api.get(this.buildUrl(ControllerName.STUDIOS, `global/promos_res`))
		},
		getGlobalPromos: async () => {
			return await $api.get(this.buildUrl(ControllerName.STUDIOS, `global/promos/`))
		},
		getStudioPromos: async (id: number) => {
			return await $api.get(this.buildUrl(ControllerName.STUDIOS, `list/promos/${id}`))
		},
		getStudioPromoResults: async (id: number) => {
			return await $api.get(this.buildUrl(ControllerName.STUDIOS, `list/promos_res/${id}`))
		},
		getStudioServices: async (id: number) => {
			return await $api.get(this.buildUrl(ControllerName.STUDIOS, `list/services/${id}`))
		},
		getCountries: async () => {
			return await $api.get(this.buildUrl(ControllerName.STUDIOS, `countries`))
		},
		getCities: async () => {
			return await $api.get(this.buildUrl(ControllerName.STUDIOS, `cities`))
		},
		getCats: async () => {
			return await $api.get(this.buildUrl(ControllerName.STUDIOS, `cats`))
		},
		addStudiosStocks: async (dto: any) => {
			return await $api.put(this.buildUrl(ControllerName.STUDIOS, `stocks/add`), dto)
		},
		deleteStudiosStocks: async (id: number) => {
			return await $api.delete(this.buildUrl(ControllerName.STUDIOS, `stocks/delete/${id}`))
		},
		getStocksStudios: async () => {
			return await $api.get(this.buildUrl(ControllerName.STUDIOS, `stocks/studios`))
		},
		getStocks: async () => {
			return await $api.get(this.buildUrl(ControllerName.STUDIOS, `stocks`))
		},
		updateStock: async (id: number, dto: any) => {
			return await $api.put(this.buildUrl(ControllerName.STUDIOS, `stocks/${id}`), dto)
		},
		createStock: async (dto: any) => {
			return await $api.post(this.buildUrl(ControllerName.STUDIOS, `stocks`), dto)
		},

		updateAllRatingReviews: async () => {
			return await $api.get(this.buildUrl(ControllerName.STUDIOS, `all_rating_reviews`))
		},
		getHashtags: async (countryId: number = 0) => {
			return await $api.get(this.buildUrl(ControllerName.STUDIOS, `hashtags?country_id=${countryId}`))
		},
		createHashtag: async (dto: any) => {
			return await $api.post(this.buildUrl(ControllerName.STUDIOS, `hashtags`), dto)
		},
		updateHashtag: async (id: number, dto: any) => {
			return await $api.put(this.buildUrl(ControllerName.STUDIOS, `hashtags/${id}`), dto)
		},
		deleteHashtag: async (id: number) => {
			return await $api.delete(this.buildUrl(ControllerName.STUDIOS, `hashtags/${id}`))
		},

		getServices: async (query: { search: string; limit: number; offset: number }) => {
			return await $api.get(this.buildUrl(ControllerName.STUDIOS, `services${this.buildParams(query)}`))
		},
		getReviews: async (query: { page: number; limit: number; search: string; user_id: string; studio_id: string }) => {
			return await $api.get(this.buildUrl(ControllerName.STUDIOS, `reviews${this.buildParams(query)}`))
		},
		getReviewsPublic: async (query: { country_code: number; page: number; limit: number }) => {
			return await $api.get(this.buildUrl(ControllerName.STUDIOS, `reviews/public${this.buildParams(query)}`))
		},
		getOrders: async (query: { page: number; limit: number; search: string; user_id: string; studio_id: string }) => {
			return await $api.get(this.buildUrl(ControllerName.STUDIOS, `orders_search${this.buildParams(query)}`))
		},
		getStudioOrders: async (
			studio_id: number,
			query: {
				page: number
				limit: number
				search: string
				user_id: string
			}
		) => {
			return await $api.get(
				this.buildUrl(ControllerName.STUDIOS, `orders_studio/${studio_id}${this.buildParams(query)}`)
			)
		},
		getMyOrders: async () => {
			return await $api.get(this.buildUrl(ControllerName.STUDIOS, `orders`))
		},
		createStudio: async (dto: any) => {
			return await $api.post(this.buildUrl(ControllerName.STUDIOS, `list`), dto)
		},
		updateStudio: async (id: number, dto: any) => {
			return await $api.put(this.buildUrl(ControllerName.STUDIOS, `list/${id}`), dto)
		},
		publishStudio: async (id: number) => $api.post(this.buildUrl(ControllerName.STUDIOS, `list/${id}/publish`)),
		updateStudioYClientsId: async (id: number, yclients_id: string) => {
			return await $api.put(this.buildUrl(ControllerName.STUDIOS, `${id}/yclients`), { yclients_id })
		},
		updateStudioScheduleSource: async (id: number, schedule_source: 'podcastbery' | 'yclients' | 'google_calendar') => {
			return await $api.put(this.buildUrl(ControllerName.STUDIOS, `${id}/schedule-source`), { schedule_source })
		},
		getAmoCrmSettings: async (id: number) => {
			return await $api.get(this.buildUrl(ControllerName.STUDIOS, `${id}/amocrm`))
		},
		saveAmoCrmSettings: async (id: number, dto: any) => {
			return await $api.put(this.buildUrl(ControllerName.STUDIOS, `${id}/amocrm`), dto)
		},
		testAmoCrmConnection: async (id: number, dto: any) => {
			return await $api.post(this.buildUrl(ControllerName.STUDIOS, `${id}/amocrm/test`), dto)
		},
		syncBookingFromYClients: async (id: number, dto: any) => {
			return await $api.post(this.buildUrl(ControllerName.STUDIOS, `${id}/booking/sync-yclients`), dto)
		},
		refreshBooking: async (id: number, dto: any) => {
			return await $api.post(this.buildUrl(ControllerName.STUDIOS, `${id}/booking/refresh`), dto)
		},
		getIammextSchedule: async (id: number) => {
			return await $api.get(this.buildUrl(ControllerName.STUDIOS, `${id}/iammext/schedule`))
		},
		createIammextBooking: async (id: number, dto: any) => {
			return await $api.post(this.buildUrl(ControllerName.STUDIOS, `${id}/iammext/bookings`), dto)
		},
		updateStudioGoogleCalendar: async (id: number, google_calendar: string) => {
			return await $api.put(this.buildUrl(ControllerName.STUDIOS, `${id}/google-calendar`), { google_calendar })
		},
		updateStudioGoogleCalendarSettings: async (id: number, google_calendar_timezone: string) => {
			return await $api.put(this.buildUrl(ControllerName.STUDIOS, `${id}/google-calendar/settings`), { google_calendar_timezone })
		},
		syncBookingFromGoogleCalendar: async (id: number, dto: any) => {
			return await $api.post(this.buildUrl(ControllerName.STUDIOS, `${id}/booking/sync-google-calendar`), dto)
		},
		deleteStudio: async (id: number) => {
			return await $api.delete(this.buildUrl(ControllerName.STUDIOS, `list/${id}`))
		},
		createOrder: async (dto: any) => {
			return await $api.post(this.buildUrl(ControllerName.STUDIOS, `order`), dto)
		},
		updateOrder: async (id: number, dto: any) => {
			return await $api.put(this.buildUrl(ControllerName.STUDIOS, `order/${id}`), dto)
		},
		deleteOrder: async (id: number) => {
			return await $api.delete(this.buildUrl(ControllerName.STUDIOS, `order/${id}`))
		},
		registerAnalyticsClick: async (dto: any) => {
			return await $api.post(this.buildUrl(ControllerName.STUDIOS, 'analytics/click'), dto)
		},
		getStudioAnalytics: async (params: { studio_id: number; start_date?: string; end_date?: string }) => {
			return await $api.get(this.buildUrl(ControllerName.STUDIOS, 'analytics'), { params })
		},
		createBooking: async (dto: any) => {
			return await $api.post(this.buildUrl(ControllerName.STUDIOS, `booking`), dto)
		},
		updateBooking: async (id: number, dto: any) => {
			return await $api.put(this.buildUrl(ControllerName.STUDIOS, `booking/${id}`), dto)
		},
		deleteBooking: async (id: number) => {
			return await $api.delete(this.buildUrl(ControllerName.STUDIOS, `booking/${id}`))
		},
		createCountry: async (dto: any) => {
			return await $api.post(this.buildUrl(ControllerName.STUDIOS, `countries`), dto)
		},
		updateCountry: async (id: number, dto: any) => {
			return await $api.put(this.buildUrl(ControllerName.STUDIOS, `countries/${id}`), dto)
		},
		deleteCountry: async (id: number) => {
			return await $api.delete(this.buildUrl(ControllerName.STUDIOS, `countries/${id}`))
		},
		createCity: async (dto: any) => {
			return await $api.post(this.buildUrl(ControllerName.STUDIOS, `cities`), dto)
		},
		updateCity: async (id: number, dto: any) => {
			return await $api.put(this.buildUrl(ControllerName.STUDIOS, `cities/${id}`), dto)
		},
		deleteCity: async (id: number) => {
			return await $api.delete(this.buildUrl(ControllerName.STUDIOS, `cities/${id}`))
		},
		createCategory: async (dto: any) => {
			return await $api.post(this.buildUrl(ControllerName.STUDIOS, `cats`), dto)
		},
		updateCategory: async (id: number, dto: any) => {
			return await $api.put(this.buildUrl(ControllerName.STUDIOS, `cats/${id}`), dto)
		},
		deleteCategory: async (id: number) => {
			return await $api.delete(this.buildUrl(ControllerName.STUDIOS, `cats/${id}`))
		},
		getLikes: async () => {
			return await $api.get(this.buildUrl(ControllerName.STUDIOS, 'likes'))
		},
		likeStudio: async (id: number) => {
			return await $api.post(this.buildUrl(ControllerName.STUDIOS, `like/${id}`), {})
		},
		// -----------------------------------------------------------------------------------------
		// BANNERS

		getBannerById: async (id: number) => {
			return await $api.get(this.buildUrl(ControllerName.STUDIOS, `banners/${id}`))
		},
		getBanners: async () => {
			return await $api.get(this.buildUrl(ControllerName.STUDIOS, `banners`))
		},
		clickBannerItem: async (id: number) => {
			return await $api.post(this.buildUrl(ControllerName.STUDIOS, `banner/item/${id}/click`), {})
		},
		createBanner: async (dto: any) => {
			return await $api.post(this.buildUrl(ControllerName.STUDIOS, `banners`), dto)
		},
		updateBanner: async (dto: any) => {
			return await $api.put(this.buildUrl(ControllerName.STUDIOS, `banners`), dto)
		},
		deleteBanner: async (id: number) => {
			return await $api.delete(this.buildUrl(ControllerName.STUDIOS, `banners/${id}`))
		},

		// BANNER ITEMS
		createBannerItem: async (dto: any) => {
			return await $api.post(this.buildUrl(ControllerName.STUDIOS, `banner/item`), dto)
		},
		updateBannerItem: async (dto: any) => {
			return await $api.put(this.buildUrl(ControllerName.STUDIOS, `banner/item`), dto)
		},
		deleteBannerItem: async (id: number) => {
			return await $api.delete(this.buildUrl(ControllerName.STUDIOS, `banner/item/${id}`))
		},
		// -----------------------------------------------------------------------------------------

		createPromocode: async (dto: any) => {
			return await $api.post(this.buildUrl(ControllerName.STUDIOS, `promos`), dto)
		},
		updatePromocode: async (id: number, dto: any) => {
			return await $api.put(this.buildUrl(ControllerName.STUDIOS, `promos/${id}`), dto)
		},
		deletePromocode: async (id: number) => {
			return await $api.delete(this.buildUrl(ControllerName.STUDIOS, `promos/${id}`))
		},
		activatePromocode: async (dto: any) => {
			return await $api.post(this.buildUrl(ControllerName.STUDIOS, `promocode`), dto)
		},
		createGPromocode: async (dto: any) => {
			return await $api.post(this.buildUrl(ControllerName.STUDIOS, `global/promos`), dto)
		},
		updateGPromocode: async (id: number, dto: any) => {
			return await $api.put(this.buildUrl(ControllerName.STUDIOS, `global/promos/${id}`), dto)
		},
		deleteGPromocode: async (id: number) => {
			return await $api.delete(this.buildUrl(ControllerName.STUDIOS, `global/promos/${id}`))
		},
		activateGPromocode: async (dto: any) => {
			return await $api.post(this.buildUrl(ControllerName.STUDIOS, `global/promocode`), dto)
		},
		createReview: async (dto: any) => {
			return await $api.post(this.buildUrl(ControllerName.STUDIOS, `review`), dto)
		},
		updateReview: async (id: number, dto: any) => {
			return await $api.put(this.buildUrl(ControllerName.STUDIOS, `review/${id}`), dto)
		},
		deleteReview: async (id: number) => {
			return await $api.delete(this.buildUrl(ControllerName.STUDIOS, `review/${id}`))
		},
		createService: async (dto: any) => {
			return await $api.post(this.buildUrl(ControllerName.STUDIOS, `service`), dto)
		},
		updateService: async (id: number, dto: any) => {
			return await $api.put(this.buildUrl(ControllerName.STUDIOS, `service/${id}`), dto)
		},
		deleteService: async (id: number) => {
			return await $api.delete(this.buildUrl(ControllerName.STUDIOS, `service/${id}`))
		},

		getServs: async () => {
			return await $api.get(this.buildUrl(ControllerName.STUDIOS, 'servs'))
		},
		createServ: async (dto: any) => {
			return await $api.post(this.buildUrl(ControllerName.STUDIOS, `servs`), dto)
		},
		updateServ: async (id: number, dto: any) => {
			return await $api.put(this.buildUrl(ControllerName.STUDIOS, `servs/${id}`), dto)
		},
		deleteServ: async (id: number) => {
			return await $api.delete(this.buildUrl(ControllerName.STUDIOS, `servs/${id}`))
		},

		getFacils: async () => {
			return await $api.get(this.buildUrl(ControllerName.STUDIOS, 'facils'))
		},
		createFacil: async (dto: any) => {
			return await $api.post(this.buildUrl(ControllerName.STUDIOS, `facils`), dto)
		},
		updateFacil: async (id: number, dto: any) => {
			return await $api.put(this.buildUrl(ControllerName.STUDIOS, `facils/${id}`), dto)
		},
		deleteFacil: async (id: number) => {
			return await $api.delete(this.buildUrl(ControllerName.STUDIOS, `facils/${id}`))
		},

		getCases: async (sid: number) => {
			return await $api.get(this.buildUrl(ControllerName.STUDIOS, `cases/${sid}`))
		},
		createCase: async (dto: any) => {
			return await $api.post(this.buildUrl(ControllerName.STUDIOS, `cases`), dto)
		},
		updateCase: async (id: number, dto: any) => {
			return await $api.put(this.buildUrl(ControllerName.STUDIOS, `cases/${id}`), dto)
		},
		deleteCase: async (id: number) => {
			return await $api.delete(this.buildUrl(ControllerName.STUDIOS, `cases/${id}`))
		},
	}

	static blog = {
		getPodcasts: async (query: any) => {
			return await $api.get(this.buildUrl(ControllerName.BLOG, `podcasts${this.buildParams(query)}`))
		},
		getPodcastById: async (id: number) => {
			return await $api.get(this.buildUrl(ControllerName.BLOG, `podcast/${id}`))
		},
		getPodcastByLink: async (link: string) => {
			return await $api.get(this.buildUrl(ControllerName.BLOG, `podcasts/${link}`))
		},
		likePodcast: async (id: number) => {
			return await $api.post(this.buildUrl(ControllerName.BLOG, `podcasts/${id}/like`))
		},
		createPodcast: async (dto: any) => {
			return await $api.post(this.buildUrl(ControllerName.BLOG, `podcasts`), dto)
		},
		updatePodcast: async (id: number, dto: any) => {
			return await $api.put(this.buildUrl(ControllerName.BLOG, `podcasts/${id}`), dto)
		},
		deletePodcast: async (id: number) => {
			return await $api.delete(this.buildUrl(ControllerName.BLOG, `podcasts/${id}`))
		},

		getPosts: async (query: {
			search: string
			tag: string
			page: number
			limit: number
			order: string
			orderBy: string
		}) => {
			return await $api.get(this.buildUrl(ControllerName.BLOG, `list${this.buildParams(query)}`))
		},
		getPostByLink: async (link_name: string) => {
			return await $api.get(this.buildUrl(ControllerName.BLOG, `list/${link_name}/bylink`))
		},
		getPost: async (id: number) => {
			return await $api.get(this.buildUrl(ControllerName.BLOG, `list/${id}`))
		},
		createPost: async (dto: any) => {
			return await $api.post(this.buildUrl(ControllerName.BLOG, `list`), dto)
		},
		updatePost: async (id: number, dto: any) => {
			return await $api.put(this.buildUrl(ControllerName.BLOG, `list/${id}`), dto)
		},
		deletePost: async (id: number) => {
			return await $api.delete(this.buildUrl(ControllerName.BLOG, `list/${id}`))
		},

		likePost: async (id: number) => {
			return await $api.post(this.buildUrl(ControllerName.BLOG, `list/${id}/like`), {})
		},
		lookPost: async (id: number) => {
			return await $api.post(this.buildUrl(ControllerName.BLOG, `list/${id}/look`), {})
		},
		commentPost: async (id: number, dto: any) => {
			return await $api.post(this.buildUrl(ControllerName.BLOG, `list/${id}/comment`), dto)
		},
		updateComment: async (id: number, cid: number, dto: any) => {
			return await $api.put(this.buildUrl(ControllerName.BLOG, `list/${id}/comment/${cid}`), dto)
		},
		deleteComment: async (id: number, cid: number) => {
			return await $api.delete(this.buildUrl(ControllerName.BLOG, `list/${id}/comment/${cid}`))
		},
		addPostTag: async (id: number, tag_id: number) => {
			return await $api.post(this.buildUrl(ControllerName.BLOG, `list/${id}/tag/${tag_id}`), {})
		},
		deletePostTag: async (id: number, tag_id: number) => {
			return await $api.delete(this.buildUrl(ControllerName.BLOG, `list/${id}/tag/${tag_id}`), {})
		},
		getTags: async () => {
			return await $api.get(this.buildUrl(ControllerName.BLOG, `tags`))
		},
		buildTags: async (type: string) => {
			return await $api.get(this.buildUrl(ControllerName.BLOG, `tags/build/${type}`))
		},
		createTag: async (dto: any) => {
			return await $api.post(this.buildUrl(ControllerName.BLOG, `tags`), dto)
		},
		updateTag: async (id: number, dto: any) => {
			return await $api.put(this.buildUrl(ControllerName.BLOG, `tags/${id}`), dto)
		},
		deleteTag: async (id: number) => {
			return await $api.delete(this.buildUrl(ControllerName.BLOG, `tags/${id}`))
		},
	}

	static core = {
		createMail: async (dto: any) => {
			return await $api.post(this.buildUrl(ControllerName.CORE, `mail`), dto)
		},
		getSettings: async () => {
			return await $api.get(this.buildUrl(ControllerName.CORE, `settings`))
		},
		updateSetting: async (id: number, dto: any) => {
			return await $api.put(this.buildUrl(ControllerName.CORE, `settings/${id}`), dto)
		},
		getImageRes: async (filename: string) => {
			return await $api.get(this.buildUrl(ControllerName.CORE, `image/${filename}`))
		},
	}

	static versions = {
		getVersions: async () => {
			return await $api.get(this.buildUrl(ControllerName.CORE, `versions`))
		},
		getLatestVersion: async () => {
			return await $api.get(this.buildUrl(ControllerName.CORE, `versions/latest`))
		},
		createVersion: async () => {},
		updateVersion: async () => {},
		deleteVersion: async () => {},
	}

	static buildUrl(controller: ControllerName, method: string) {
		return `${API_URL}${controller}/${method}`
	}

	static buildParams(map: any) {
		let query = ''
		for (let key in map) {
			if (query == '') {
				query = `?${key}=${map[key]}`
			} else {
				query += `&${key}=${map[key]}`
			}
		}
		return query
	}
}
